import { ReactNode } from 'react';
import classNames from 'classnames';

import hcLogo from '../../../assets/images/logo/logo-green-xl.png';
import EnvironmentBadge from '../EnvironmentBadge';

export type UnauthedHeaderBranding = {
  primary_color: string;
  secondary_color: string;
  wordmark_logo_url: string;
  square_logo_url: string;
};

type UnauthedHeaderProps = {
  branding?: UnauthedHeaderBranding | null;
  /** Optional content on the right (e.g. Download PDF). */
  actions?: ReactNode;
  /**
   * Constrain logo/actions to the same max width as the note body (max-w-5xl).
   */
  alignToContent?: boolean;
};

const UnauthedHeader = ({
  branding,
  actions,
  alignToContent = false,
}: UnauthedHeaderProps) => {
  const logoUrl =
    branding?.wordmark_logo_url || branding?.square_logo_url || null;

  return (
    <header
      className={classNames(
        'fixed z-20 h-16 w-full',
        'border-b border-neutral-50 bg-neutral-25 text-caption font-medium text-green-150',
      )}
    >
      <div
        className={classNames(
          'flex h-full w-full flex-row items-center justify-between',
          alignToContent ? 'mx-auto max-w-5xl px-6' : 'px-6 md:px-20',
        )}
      >
        <div className="flex flex-row items-center justify-start">
          <div className="mr-5 flex h-full items-center justify-center gap-3">
            {logoUrl ? (
              <img
                src={logoUrl}
                className="h-[36px] max-w-[180px] object-contain object-left"
                alt=""
              />
            ) : (
              <img src={hcLogo} className="h-[36px] w-[36px]" alt="logo" />
            )}
            <EnvironmentBadge />
          </div>
        </div>
        {actions ? (
          <div className="flex shrink-0 items-center">{actions}</div>
        ) : null}
      </div>
    </header>
  );
};

export default UnauthedHeader;
